module.exports = __webpack_public_path__ + "img/vendict-b-logo.7ed361d.svg";